module.exports = __webpack_public_path__ + "img/email_section_img.04ada474.jpg";